import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addOrUpdateFarmFeatureFlagAdmin } from "services";

import { ADD_OR_UPDATE_FARM_FEATURE_FLAG, GET_FARM_FEATURE_FLAGS } from "consts";

export const useAddOrUpdateFarmFeatureFlagAdmin = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  const isAdmin = true;
  return useMutation({
    mutationKey: [ADD_OR_UPDATE_FARM_FEATURE_FLAG],
    mutationFn: addOrUpdateFarmFeatureFlagAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_FEATURE_FLAGS, farmId, isAdmin] });
    },
  });
};
